export default __webpack_public_path__ + "static/media/suit-case-icon.c7a6cdd0.svg";